import { Button, Flex, Text } from '@radix-ui/themes';
import { t } from 'i18next';
import { IButton } from 'interfaces/i-buttons';
import { StringHelper } from 'lib_ts/classes/string.helper';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useMemo } from 'react';

export const CommonTableButton = (props: IButton) => {
  const className = useMemo(
    () => StringHelper.classNames([props.className, 'CommonTableButton']),
    [props.className]
  );

  return (
    <Button
      size={props.size || RADIX.BUTTON.SIZE.TABLE}
      title={props.tooltip}
      disabled={props.disabled}
      className={className}
      color={props.color}
      variant={props.variant}
      onClick={props.onClick}
      loading={props.loading}
    >
      <Text truncate>
        <Flex align="center">
          {props.icon}&nbsp;{props.label && t(props.label)}&nbsp;
          {props.suffixIcon}
        </Flex>
      </Text>
    </Button>
  );
};
